module.exports = __webpack_public_path__ + "img/samsung3.f13b866d.png";